<template>
  <div>
    <reservation-form />
    <contact-form />
  </div>
</template>

<script>
import ReservationForm from './ReservationForm.vue'
import ContactForm from './ContactForm.vue'

export default {
  components: {
    ReservationForm,
    ContactForm
  }
}
</script>
